var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCartSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_My_cart",
    "data-name": "Icon / My cart",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shopping_cart-black-18dp"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M0,0H24V24H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M15.994,20a2,2,0,1,1,2-2A2,2,0,0,1,15.994,20ZM6,20a2,2,0,1,1,2-2A2,2,0,0,1,6,20Zm12-5H6a1.977,1.977,0,0,1-1.714-.975,2,2,0,0,1-.036-1.995L5.6,9.59,2,2H0V0H3.269l.94,2H19a1,1,0,0,1,.87,1.481L16.294,9.97A1.989,1.989,0,0,1,14.545,11H7.1L6,13h12v2ZM5.158,4l2.37,5h7.017L17.3,4H5.158Z",
    transform: "translate(1 2)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCartSmall);
export default __webpack_public_path__ + "static/media/icon-cart-small.2e42e4853ccca6ff216b12a57e138a0b.svg";
export { ForwardRef as ReactComponent };